import {ajaxCallWrapper} from "./ajaxStatusHelper";
import {toastr} from 'react-redux-toastr'
import shapen from '../shapeners/basicShapener'
import {getZazzleLink, getZazzleMugLink, getZazzleTShirtLink} from "../temporaryStorage/getTemporaryLink";
import { resolveActivePromo } from '../promos/resolveActivePromo';
import { getPromoProductId } from '../promos/promoSkus';
import { tcForPromo } from '../promos/promoTypes';
import { trackPromoCheckoutClick } from '../utils/promoAnalytics';

export function shape(file, shapeFile, canvas, opts, callback) {
    return function (dispatch) {
        return ajaxCallWrapper(
            dispatch,
            new Promise(async function (resolve, reject) {
                try {
                    setTimeout(async () => {
                        try {
                            const fileData = await shapen(file, shapeFile, canvas, opts);

                            resolve(fileData);
                        } catch (e) {
                            reject(e);
                        }
                    }, 0);
                } catch (e) {
                    reject(e);
                }
            }).then(fileData => {
                callback(fileData);
            }).catch(error => {
                toastr.error(error.message || "Unexpected error");
            }));
    }
}

export function makeACup(url, shape, newWindow) {
    return function (dispatch) {
        let link = getZazzleMugLink(url, shape.name);
        window.open(link, "_blank");
    }
}

export function makeATShirt(url, shape, newWindow) {
    return function (dispatch) {
        let link = getZazzleTShirtLink(url, shape.name);
        window.open(link, "_blank");
    }
}

/**
 * Open Zazzle's product builder for any catalog product.
 *
 * Products that don't support a caption ignore the label automatically —
 * the template just has no caption layer bound to `t_name_txt`.
 *
 * When a promo is active for the current visitor and a discounted Zazzle
 * SKU exists for this product + discount level + variant, route to that
 * SKU instead and stamp the Zazzle `tc=` attribution with the promo code
 * (for code promos). When no promo SKU has been configured for the exact
 * variant the visitor selected, silently fall back to the base (full-
 * price) SKU OF THE SAME VARIANT — we never swap labeled/no-label
 * because that would change the design.
 *
 * Detecting which variant we were called with: ProductGallery builds an
 * `effectiveProduct` where, when the visitor checked "No caption",
 * `zazzleProductId` is set to `noLabelProductId`. So equality between
 * those two fields is the no-label signal.
 */
export function orderProduct(imageUrl, product, label) {
    return function (dispatch, getState) {
        const effectiveLabel = product.supportsLabel ? (label || '') : '';
        const state = getState();
        const promoState = state.promos || {};
        const activePromo = resolveActivePromo({
            promos: promoState.list || [],
            now: Date.now(),
            urlCode: promoState.urlCode,
            enteredCode: promoState.enteredCode,
        });

        const isNoLabelVariant = Boolean(
            product.noLabelProductId
            && product.zazzleProductId === product.noLabelProductId
        );

        let zazzleProductId = product.zazzleProductId;
        if (activePromo) {
            const promoSku = getPromoProductId(
                product.id,
                activePromo.discountPercent,
                { noLabel: isNoLabelVariant },
            );
            if (promoSku) {
                zazzleProductId = promoSku;
                trackPromoCheckoutClick({
                    promoId: activePromo.id,
                    code: activePromo.code || null,
                    discountPercent: activePromo.discountPercent,
                    productId: promoSku,
                    productKey: isNoLabelVariant ? `${product.id}_no_label` : product.id,
                });
            } else {
                // No promo SKU for this exact variant. Fall through to the
                // base (full-price) SKU of the SAME variant — never swap
                // labeled/no-label or the visitor's design changes. The
                // ribbon will still show "promo applied"; logged so misconfig
                // is easy to spot.
                // eslint-disable-next-line no-console
                console.warn(
                    `[promo] No discounted ${isNoLabelVariant ? 'noLabel' : 'base'} SKU for `
                    + `${product.id} @ ${activePromo.discountPercent}%; opening base SKU.`,
                );
            }
        }

        const tc = tcForPromo(activePromo);
        const link = getZazzleLink(zazzleProductId, imageUrl, effectiveLabel, tc);
        window.open(link, '_blank');
    };
}
